var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-planet"},[_c('Planet',{attrs:{"moons":_vm.objects,"colors":_vm.colors,"showMoons":_vm.showMoons,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }